import axiosInstance from "../axiosInstance";
import { endpoints } from "../endpoints";

export const getCompanies = async () => {
  const res = await axiosInstance.get(endpoints.company.companiesList);
  return res.data;
};
